import { Box, Typography } from "@mui/material";
import { TechnicianPriority, PriorityData } from "../../utils/types";
import { Avatar } from "../../../fieldsViews/fields/Avatar";

type CustomEventProps = {
    props: any;
    prioritiesData?: PriorityData;
};
export const CustomEvent = ({ props, prioritiesData }: CustomEventProps) => {
    const getPriorityBorderColor = (priority: string) => {
        switch (priority) {
            case "high":
                return "success.main";
            case "medium":
                return "warning.main";
            case "low":
                return "error.main";
            default:
                return "info.main";
        }
    };

    let borderColor = "error.main";
    if (props.event.slotData.user && prioritiesData) {
        const userId = props.event.slotData.user.id || props.event.slotData.user.user_id || null;
        const targetAgeGroup = prioritiesData.filters.age_groups;
        const targetDisorder = prioritiesData.filters.disorder_specialization;
        if (userId && targetAgeGroup && targetDisorder) {
            const matchingPriority = prioritiesData.priorities.find(
                (p: TechnicianPriority) =>
                    p.technician?.user_id?.id === userId &&
                    p.age_group?.id === targetAgeGroup &&
                    p.disorder?.id === targetDisorder
            );
            if (matchingPriority) {
                borderColor = getPriorityBorderColor(matchingPriority.priorty);
            }
        }
    }

    return (
        <Box display="flex" alignItems="flex-start" width="100%" sx={{ position: "relative" }}>
            <Typography variant="caption">{props.event.title}</Typography>
            {props.event.slotData.user?.avatar && (
                <Box
                    sx={{
                        ml: 1,
                        mt: -3,
                        width: 34,
                        height: 34,
                        border: '1px solid white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxSizing: 'border-box',
                    }}
                >
                    <Avatar
                        value={props.event.slotData.user?.avatar}
                        styles={{
                            width: 30,
                            height: 30,
                            border: 3,
                            borderColor: borderColor,
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};
